import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { ProductCatalogModel } from '@/interfaces/model';
import type { StrapiResponse } from '@/interfaces/strapi';
import { loadAbort } from '@/utils';

type CatalogProductRequest = {
	name: string;
	nif: string;
	email: string;
	phone: string;
	address: string;
	addressFactura: string;
	productos: string[];
	acceptedPolicy: boolean;
};

export const createProductRequest = (
	values: CatalogProductRequest,
): UseApiCall<StrapiResponse<ProductCatalogModel>> => {
	const controller = loadAbort();
	const url = '/solicitudes-catalogos';

	return {
		call: strapiInstance.post<StrapiResponse<ProductCatalogModel>>(
			url,
			{
				data: {
					name: values.name,
					nif: values.nif,
					email: values.email,
					phone: values.phone,
					address: values.address,
					addressFactura: values.addressFactura,
					acceptedPolicy: true,
					productos: { connect: values.productos },
				},
			},
			{ signal: controller.signal },
		),
		controller,
	};
};
